import { AsyncPipe } from '@angular/common';
import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  Input,
  ViewChild,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MessageManagementModel } from '@ay-gosu/server-shared';
import { from, Observable, of } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { MatTooltip } from '../../material/tooltip/tooltip';
import { FactoryComponent } from '../factory/factory.component';
import { PackageFactoryService } from '../package-factory.service';
import { Package } from '../package.class';
@Component({
  selector: 'ms-share-preview',
  templateUrl: './share-preview.component.html',
  styleUrls: ['./share-preview.component.scss'],
  imports: [MatIcon, MatTooltip, AsyncPipe, forwardRef(() => FactoryComponent)],
})
export class SharePreviewComponent implements AfterViewChecked {
  @Input()
  public package: Package;

  @Input()
  public messageId: number;

  @Input()
  public shareCurrentMessage: boolean;

  @ViewChild('wrapper')
  public wrapper: ElementRef;

  @ViewChild('icon')
  public icon: MatIcon;

  public previewPackageObservables = new Map<number, Observable<Package>>();

  private iconInitialized = false;

  public constructor(
    private readonly _packageFactoryService: PackageFactoryService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
    private readonly _elementRef: ElementRef,
  ) {}

  public ngAfterViewChecked() {
    if (!this.iconInitialized && this.icon) {
      this.iconInitialized = true;
      this.resizeIcon();
    }

    if (!this.icon) {
      this.iconInitialized = false;
    }
  }

  public getPreviewPackage$(messageId: number): Observable<Package> {
    if (this.shareCurrentMessage || messageId === -1) {
      return of(new Package(null, null));
    }

    if (!this.previewPackageObservables.has(messageId)) {
      const obs$ = from(this._fetchButtonPreviewPackage(messageId)).pipe(
        shareReplay(1),
      );
      this.previewPackageObservables.set(messageId, obs$);
    }
    return this.previewPackageObservables.get(messageId);
  }

  public resizePreview(messagePreview: HTMLElement) {
    setTimeout(() => {
      this._changeDetectorRef.detectChanges();

      const height = messagePreview.offsetHeight;
      const parentHeight = messagePreview.parentElement.offsetHeight;

      const scaleFactor = (parentHeight / height) * 0.9;

      messagePreview.style.transform = `scale(${scaleFactor})`;
      messagePreview.style.transformOrigin = `top right`;
    });
  }

  public resizeIcon() {
    this._changeDetectorRef.detectChanges();
    const parentHeight =
      this._elementRef.nativeElement.parentElement.offsetHeight;

    const height = parentHeight > 32 ? 32 : parentHeight * 0.9;

    this.wrapper.nativeElement.style.width = `${height}px`;
    this.wrapper.nativeElement.style.height = `${height}px`;

    this.icon._elementRef.nativeElement.style.fontSize = `${height * 0.6}px`;
    this.icon._elementRef.nativeElement.style.width = `${height * 0.6}px`;
    this.icon._elementRef.nativeElement.style.height = `${height * 0.6}px`;
  }

  private async _fetchButtonPreviewPackage(messageId: number) {
    if (!messageId) {
      return;
    }

    try {
      const pkgFetched = await MessageManagementModel.fetchPackage(messageId);
      const pkg =
        await this._packageFactoryService.createForMessageManagement(
          pkgFetched,
        );

      return pkg;
    } catch (error) {
      console.error(error);
      return;
    }
  }
}
